<template>
	<div class="container">
		<a-scene
			:background="backgroundcolor"
			:fog="fog"
			renderer="colorManagement: true;"
			render-enabled
			embedded
			vr-mode-ui="enabled: false"
			keyboard-shortcuts="enterVR:false;"
			shadow="type: basic"
			physics="friction: 0.02;
			restitution:0;
			contactEquationStiffness:1e8;
			contactEquationRelaxation:3;
			iterations:10;">
			<a-entity :light="ambient"/>
			<a-entity
				light="
					type:directional;
					color:#FFF;
					intensity:1.1;
					castShadow:true;
					shadowCameraLeft:-11;
					shadowCameraRight:11;
					shadowCameraTop:11;
					shadowCameraBottom:-11;
					shadowMapHeight:2048;
					shadowMapWidth:2048;
					shadowCameraFar:20;
					shadowCameraNear:0.5;
					shadowBias:-0.0003;
				"
				position="-2 4 4"/>
			<a-entity
				id="camera"
				camera
				orbit-controls="target: 0 1.6 -3.5; minDistance: 0.5; maxDistance: 180; initialPosition: 0 4.6 -1; enableZoom:false;enablePan:false;maxPolarAngle:60;minPolarAngle:0;">
				<a-entity
					cursor="rayOrigin: mouse;"
					raycaster="objects: .clickable; near: 0.1; far:50;"/>
			</a-entity>
			<a-entity
				:gltf-model="sink"
				:envmap="envmap"
				class="clickable" 
				position="-1 7 -6.5"
				data-startpos="-1 7 -4.5"
				scale="0.002 0.002 0.002"
				shadow
				animation__drop="property:position; to: -1 -0.03 -4.5;dur:2000; autoplay:true; easing:easeOutSine;"
				@animationcomplete="becomeMovable"/>
			<a-entity
				position="2 7 -5"
				data-startpos="2 7 -5"
				scale="0.002 0.002 0.002"
				geometry="primitive: box; width:400;height:1600;depth:400"
				material="transparent:true;opacity:0;renderOrder:0;"
				animation__drop="property:position; to: 2 1.65 -5;dur:2000; autoplay:true; easing:easeOutSine;"
				@animationcomplete="becomeMovable">
				<a-entity
					:envmap="envmap"
					:gltf-model="tallcab"
					class="clickable"
					position="-1050 -820 200"
					shadow/>
			</a-entity>
			<a-entity
				:envmap="envmap"
				:gltf-model="bath"
				class="clickable" 
				position="0 7 -1.5" 
				scale="0.002 0.002 0.002"
				data-startpos="-2 7 -2.5"
				shadow
				animation__drop="property:position; to: 0 0.05 -2.5;dur:2000; autoplay:true; easing:easeOutSine;"
				@animationcomplete="becomeMovable"/>
			<a-entity
				:material="floor"
				position="0 0 -4"
				geometry="primitive:cylinder;radius:20;height:0.1;"
				shadow/>
			<a-entity
				geometry="primitive:cylinder;radius:9;height:0.1;"
				static-body
				position="0 -0.002 -4"/>
		</a-scene>
	</div>
</template>
<script>
if (process.browser) {
	if (!window.AFRAME) {
		require('aframe');
	}
	if (!AFRAME.components['dynamic-body']) {
		require('aframe-physics-system');
	}
	if (!AFRAME.components['orbit-controls']) {
		require('aframe-orbit-controls');
	}
	require('../../plugins/movablexz.js');
	require('../../plugins/intersect-plane.js');
	require('../../plugins/envmap.js');
	require('../../plugins/aframedestroy.js');
}
export default {
	props: {
		// backgroundColour: {
		// 	type: String,
		// 	default: '#3cb2ac',
		// 	required: false
		// },
		assetRoot: {
			type: String,
			default: "https://lab.pikcells.com/assets/",
			required: false
		}
	},
	computed: {
		hash: function() {
			return window.location.hash || "#FFFFFF";
		},
		bath: function() {
			return this.assetRoot + 'models/bath/Bath.gltf';
		},
		tallcab: function() {
			return (
				this.assetRoot + 'models/cabinets/TALL_CAB.gltf'
			);
		},
		envmap: function() {
			return (
				'src:' +
				this.assetRoot +
				'cubes/studio;intensity:1;'
			);
		},
		sink: function() {
			return (
				this.assetRoot + 'models/cabinets/SINK_CAB.gltf'
			);
		},
		fog: function() {
			return 'type: linear; near:6; far:10; color: ' + this.hash;
		},
		backgroundcolor: function() {
			return 'color:' + this.hash; // this.backgroundColour;
		},
		floor: function() {
			return (
				'src:https://lab.pikcells.com/assets/textures/plus.jpg; repeat: 30 30; color: ' +
				this.hash
			);
		},
		ambient: function() {
			return 'type:ambient; intensity:0.3; color: ' + this.hash;
		}
	},
	destroyed: function(event) {
		AFRAME.destory();
	},
	methods: {
		becomeMovable: function(event) {
			event.target.setAttribute(
				'movablexz',
				'startPos:' + event.target.getAttribute('data-startpos') + ';'
			);
		}
	}
};
</script>
<style>
a-scene {
	width: 100%;
	height: 100%;
}
.container {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
}
.turn-container {
	position: absolute;
	bottom: 0;
	width: 100%;
	margin-bottom: 10px;
}
</style>
